import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import Divider from "@material-ui/core/Divider";
import {getTranslation} from "../../helpers/get-translation";
import SettingsOptionButton from "./settings-option-button"
import UploadAvatar, {AVATAR_INPUT_ID} from "./upload-avatar";

function SettingsOptionChangeAvatar(props) {
	const onClick = () => {
		const changeAvatarInput = document.getElementById(AVATAR_INPUT_ID);
		if(changeAvatarInput !== null){
			changeAvatarInput.click()
		}
	};

	return (
		<div>
			<UploadAvatar />
			<SettingsOptionButton {...props} onClick={onClick}/>
		</div>
	);
}

SettingsOptionChangeAvatar.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	isLast: PropTypes.bool,
	hasCircleImage: PropTypes.bool,
};

export default SettingsOptionChangeAvatar;
